import _ from 'lodash';

export const USER_ACTIVITY_EVENTS = [
    'mousemove',
    'click',
    'mousedown',
    'touchstart',
    'keypress'
];

export const USER_ACTIVITY_EVENT = 'davinci-user-active';

const USER_IDLE_THRESHOLD = 30000;

let lastActivity = Date.now();
let initialized = false;
let idle = false;
let idleTimeout = null;

const scheduleIdleDetection = () => {
    if (idleTimeout)
        clearTimeout(idleTimeout);

    idleTimeout = setTimeout(() => {
        idle = true;
    }, USER_IDLE_THRESHOLD);
};

const markActivity = _.throttle(() => {
    const wasIdle = idle;

    lastActivity = Date.now();
    idle = false;

    scheduleIdleDetection();

    if (wasIdle)
        window.dispatchEvent(new Event(USER_ACTIVITY_EVENT));
}, 500);

const handleVisibilityChange = () => {
    if (document.hidden) {
        idle = true;
        return;
    }

    const wasIdle = idle;

    lastActivity = Date.now();
    idle = false;

    scheduleIdleDetection();

    if (wasIdle)
        window.dispatchEvent(new Event(USER_ACTIVITY_EVENT));
};

export const initializeUserActivityTracking = () => {
    if (initialized)
        return;

    USER_ACTIVITY_EVENTS.forEach(
        event => document.addEventListener(event, markActivity)
    );

    document.addEventListener(
        'visibilitychange',
        handleVisibilityChange
    );

    scheduleIdleDetection();

    initialized = true;
};

export const getUserInactiveTime = () =>
    Date.now() - lastActivity;

export const isUserInactiveFor = milliseconds =>
    document.hidden ||
    getUserInactiveTime() >= milliseconds;
